module.exports = __webpack_public_path__ + "img/1 (13).99be8344.jpg";